/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { AreaDivisionBase } from "../../../../schema/generated/AreaDivision";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class AreaDivisionDataApi extends EntityDataApi<AreaDivisionBase> {
  public readonly def = idbEntityDefs.AreaDivision;
}